// src/pages/CancelPage.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CancelPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [paymentMethod, setPaymentMethod] = useState(null); // Para identificar si es Stripe o PayPal
  const [transactionId, setTransactionId] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    // Verificar si es un pago de Stripe o PayPal basado en los parámetros de la URL
    if (urlParams.has('session_id')) {
      setPaymentMethod('stripe');
      setTransactionId(urlParams.get('session_id')); // session_id de Stripe
    } else if (urlParams.has('invoice_id')) {
      setPaymentMethod('paypal');
      setTransactionId(urlParams.get('invoice_id')); // invoice_id de PayPal
    }
  }, [location]);

  const handleRetryPayment = () => {
    // Redirigir al usuario para que intente nuevamente el pago
    navigate('/'); // Asegúrate de que esta ruta de pago exista en tu aplicación
  };

  return (
    <div>
      <h1>{t('payment-failed')}</h1>
      <p>{t('payment-not-completed')}</p>
      <p>{t('try-again')}</p>

      {paymentMethod && (
        <div className="text-dark pb-2 fw-bold text-center">
          <strong>
            {paymentMethod === 'stripe' ? t('payment-made-with-stripe') : t('payment-made-with-paypal')}
          </strong>
          <p>{t('transaction-id')}: {transactionId}</p>
        </div>
      )}

      <div style={styles.buttonContainer}>
        <button onClick={handleRetryPayment} className="btn-sm btn-paynow-ipb">
          {t('back-to-invoices')}
        </button>
      </div>
    </div>
  );
};

const styles = {
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '10vh',
  },
};

export default CancelPage;
